
const AutorizacaoEspecialStepForm =
[
    {
        key: 1,
        validateAllForms: false,
        mainStep: "GuideStep",
        steps: [
            { name: "GuideForm"},
        ]
    },
    {
        key: 2,
        validateAllForms: false,
        mainStep: "PersonalDataStep",
        steps: [
            { name: "PersonalDataForm"}
        ]
    },
    {
        key: 3,
        validateAllForms: false,
        mainStep: "ParticipationRequestPatientStep",
        steps: [
            { name: "ParticipationRequestForm" },
            { name: "PatientForm" }
        ]
    },
    {
        key: 4,
        validateAllForms: true,
        mainStep: "AutorizacaoEspecialAttachmentDataStep",
        steps: [
            { name: "AttachmentForm" },
        ]
    },
    {
        key: 5,
        validateAllForms: false,
        mainStep: "TermsDeclarationsStep",
        steps: [
            { name: "TermsDeclarationsForm" },           
        ]
    }

];


export { AutorizacaoEspecialStepForm };